import React from 'react';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../style/Header.css'; // Assurez-vous d'importer le CSS

const Header = () => {
  return (
    <Navbar bg="blue" expand="lg" className="navbar-menu">
      <Navbar.Brand >FluvialCap</Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="mr-auto">
          <NavDropdown title="Le Mag’" id="nav-dropdown-mag">
            <NavDropdown.Item href="/blog">Actualités</NavDropdown.Item>
            <NavDropdown.Item href="https://docs.google.com/forms/d/e/1FAIpQLSfvfN72jjdbebAkNhPZK3iNUnZLrY-i0RJVx_TrBwql2zniyA/viewform">Sondage</NavDropdown.Item>
            <NavDropdown.Item href="/compte">Archives du Mag’</NavDropdown.Item>
          </NavDropdown>
          <NavDropdown title="Guide du marinier" id="nav-dropdown-guide">
            <NavDropdown.Item href="/adresses-utiles">Annuaire</NavDropdown.Item>
            <NavDropdown.Item href="/fluviacap">FLUVIACAP, le GPS fluvial</NavDropdown.Item>
            <NavDropdown.Item href="/tutos-conseils">Tutos / Conseils</NavDropdown.Item>
            <NavDropdown.Item href="/vignette-vnf">Vignette VNF (Péage de plaisance)</NavDropdown.Item>
            <NavDropdown.Item href="/reglementation">Réglementation</NavDropdown.Item>
            <NavDropdown.Item href="/permis">Permis</NavDropdown.Item>
            <NavDropdown.Item href="/vocabulaire-marinier">Vocabulaire du marinier</NavDropdown.Item>
          </NavDropdown>
          <NavDropdown title="Communauté" id="nav-dropdown-communaute">
            <NavDropdown.Item href="https://facebook.com/fluvialmagazine">Forum Facebook</NavDropdown.Item>
            <NavDropdown.Item href="/annonces-bateaux">Nos petites annonces</NavDropdown.Item>
            <NavDropdown.Item href="https://www.fluvialnet.com/account/login/?redirect=https%3A%2F%2Fwww.fluvialnet.com%2Fsubmit-listing%2F">Ajouter une annonce</NavDropdown.Item>
          </NavDropdown>
          <NavDropdown title="Boutiques" id="nav-dropdown-boutiques">
            <NavDropdown.Item href="/boutique">Boutique du marinier</NavDropdown.Item>
            <NavDropdown.Item href="https://www.alpha-croisiere.com">Alpha Croisière – Loueur Partenaire</NavDropdown.Item>
          </NavDropdown>
          <NavDropdown title="Voies et Bateaux" id="nav-dropdown-voies">
            <NavDropdown.Item href="/voies-navigables">Voies navigables</NavDropdown.Item>
            <NavDropdown.Item href="/fiches-bateaux">Fiches bateaux</NavDropdown.Item>
            <NavDropdown.Item href="/location-bateaux">Bases de location par région</NavDropdown.Item>
            <NavDropdown.Item href="/chantier-naval">Chantier naval</NavDropdown.Item>
            <NavDropdown.Item href="/accastillage">Entreprises d’accastillage</NavDropdown.Item>
          </NavDropdown>
          <Nav.Link href="/account/login/">Se connecter</Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Header;
